import React, {useContext} from 'react'
import axios from 'axios'
import { BaseURL } from '../../../../Files/BaseURL'
import { useEffect, useState } from 'react';
import ThemeContext from "../../../../Context/theme/ThemeContext";
import {getFileNameFromUrl, getfileTypefromurl, OfferStep} from "../../../../Files/UseFunction";
import {useNavigate} from "react-router-dom";
const OrderDetail = ({ setOrderStatus, offer}) => {

    const [user, setUser] = useState({});
    const [Step, setSteps] = useState([]);
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();

    const extractDate = (timestamp) => {
        const dateObj = new Date(timestamp);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleClick = () => {
        const path = user._id === offer.Seller._id
            ? `/user-dashboard/offers/sendchat/${offer._id}`
            : `/user-dashboard/offers/recivedchat/${offer._id}`;
        navigate(path);
    };

    const fetchUser = async () => {
        try{
            const response = await axios.get(`${BaseURL}/api/getusers/getUser`, {
                headers: {
                    "auth-token": localStorage.getItem("p@token"),
                    "Content-Type": "application/json",
                },
            });
            if(response){
                setUser(response.data.user);
                const OfferStepReturn = OfferStep(offer.Status)
                setSteps(OfferStepReturn);
            }
        }
        catch(error){
            console.log(error);
        }
    }

    useEffect(() => {
        fetchUser()
    },[user])

    return (
        <div className='fixed z-[9999] top-0 left-0 w-[100vw] h-[100vh]'>
            <div className="bg-black/50 w-[100vw] h-[100vh] absolute z-30" onClick={() => { setOrderStatus(false) }}></div>
            <div className="bg-white h-[80vh] overflow-y-auto md:h-[100vh] w-[90%] my-6 m-auto rounded-2xl md:rounded-none md:m-auto md:w-[50%] xl:w-[30%] md:right-0 relative md:absolute z-40 py-6 px-6">
                <div className="flex flex-col gap-4">
                    <h2 className='text-3xl text-black font-semibold'>Offer Detail</h2>

                        <div className="flex flex-row gap-2 items-center">
                        <button className="w-full px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-xl py-1 md:py-3 border border-black-500 hover:border-green-500 rounded-full  text-white"
                        onClick={handleClick} >
                            Go to Offer
                        </button>
                        </div>
                    <div className="border-2 border-[#E9E9E9] w-full rounded-2xl py-4 px-4">
                        <div className="flex justify-between">
                            <div className="flex flex-col gap-2">
                                <div
                                    className={`
                      py-2 px-4 rounded-lg border-2 w-max font-medium
                      ${offer?.Status === "New"
                                        ? "bg-[#8A39F2]/30 border-[#8A39F2] text-[#8A39F2]"
                                        : offer?.Status === "In progress"
                                            ? "bg-[#EBF4FE] border-[#3992F2] text-[#3992F2]"
                                            : offer?.Status === "Delivered"
                                                ? "bg-[#FCEBFE] border-[#E339F2] text-[#E339F2]"
                                                : offer?.Status === "Completed"
                                                    ? "bg-[#EFFBF1] border-[#63D577] text-[#63D577]"
                                                    : offer?.Status === "Under review"
                                                        ? "bg-[#FEF8EE] border-[#F9B754] text-[#F9B754]"
                                                        : "bg-[#FCEBEC] border-[#DD3242] text-[#DD3242]"
                                    }
                    `}
                                >
                                    {offer?.Status}
                                </div>
                                {/*<div className={`py-2 px-4 rounded-lg border-2 w-fit font-medium bg-[#8A39F2]/30 border-[#8A39F2] text-[#8A39F2]`}>*/}
                                {/*    {offer?.Status}*/}
                                {/*</div>*/}
                                <h2 className='text-lg font-semibold'>Payment for {offer?.Title}</h2>
                            </div>
                            <div className="flex flex-col gap-2">
                                <p className='text-sm text-gray-400'>{extractDate(offer?.date)}</p>
                                <p className='font-medium text-primarygreen'>${offer?.Price.toFixed(2)}</p>
                            </div>
                        </div>
                        <p className='font-medium'>{offer?.Type}</p>
                    </div>
                    <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
                        <p className='text-lg text-gray-400'>{user._id === offer.Seller._id ? <>Buyer</> : <>Seller</>}</p>
                        <div className="flex flex-row gap-2 items-center">
                            {/*<img src={`${user._id === offer.Seller._id ? offer.Buyer.ProfilePhoto : offer.Seller.ProfilePhoto}`}  alt="" className='w-8 h-8' />*/}
                            {(offer?.Seller?.ProfilePhoto && user._id === offer.Buyer._id) || (offer?.Buyer?.ProfilePhoto && user._id === offer.Seller._id) ? (
                                <img
                                    src={user._id === offer.Seller._id ? offer.Buyer?.ProfilePhoto : offer.Seller?.ProfilePhoto}
                                    alt="Profile"
                                    className="rounded-full w-8 md:w-12 h-8 md:h-12"
                                />
                            ) : (
                                <div
                                    className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center ${theme === "dark" ? "bg-black text-white" : ""}`}
                                >
                                    <span className="text-white">{user._id === offer.Seller._id ? offer.Buyer?.FirstName?.charAt(0) : offer.Seller?.FirstName?.charAt(0)}</span>
                                </div>
                            )}

                            <h2 className='font-semibold'>{user._id === offer.Seller._id ? <>{offer.Buyer.FirstName} {offer.Buyer.LastName}</> : <>{offer.Seller.FirstName} {offer.Seller.LastName}</>}</h2>
                        </div>
                    </div>
                    <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
                        <p className='text-lg text-gray-400'>Attached files</p>
                        <div className="flex flex-col gap-2">
                            {offer?.FileAttached?.map((item, index) => (
                                <a href={item.src} target='_blank' download={true}
                                   className="flex flex-row gap-2 items-center" key={index}>
                                    <img
                                        src={getfileTypefromurl(item.src) == "pdf" ? "../../../Assets/Prop/pdf.png" : "../../../Assets/Prop/IDIcon.png"}
                                        alt="" className='w-8 h-8'/>
                                    <h2 className='font-semibold'>{getFileNameFromUrl(item.src)}</h2>
                                </a>
                            ))}
                        </div>
                        {/*<div className="flex flex-row gap-2 items-center">*/}
                        {/*    <img src="../../Assets/Prop/pdf.png" alt="" className='w-8 h-8' />*/}
                        {/*    <h2 className='font-semibold'>{offer?.FilesAttached}</h2>*/}
                        {/*</div>*/}
                    </div>
                    <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
                        <p className='text-lg text-gray-400'>Offer timeline</p>
                        {/*<div className="flex flex-row items-center justify-between">*/}
                        {/*<div className="flex flex-row gap-2 items-center">*/}
                        {/*    <img src="../../Assets/Prop/tick.png" alt="" className='w-6 h-6'/>*/}
                        {/*    <h2 className='font-semibold'></h2>*/}
                        {/*</div>*/}
                        {/*<p className='text-lg text-gray-400'>04 Dec</p>*/}
                        {/*</div>*/}
                        <div className="flex flex-col gap-1">
                            {Step?.map((step, i) => (
                                <div className="flex flex-row items-center justify-between" key={i}>
                                    <div className="flex flex-row gap-2 items-center">
                                        <img src="../../../Assets/Prop/tick.png" alt="" className='w-6 h-6'/>
                                        <h2 className='font-semibold'>{step.stage}</h2>
                                    </div>
                                    <p className='text-lg text-gray-400'>04 Dec</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderDetail